import { useTranslation } from "src/hooks";
import { TableColumnKey } from "src/views/Ledger/LedgerBalanceMonitor/types/Table";
import { AddLedgerBalanceMonitorFields } from "../../..";
import { Dispatch, SetStateAction } from "react";
import ChainNameSingleSelection from "./components/ChainNameSingleSelection";
import CurrencySingleSelection from "./components/CurrencySingleSelection";
import { Box } from "src/components/MuiGenerals";
import ClientIdTextField from "./components/ClientIdTextField";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";

function LedgerFieldSection({
  fields,
  setFields,
}: {
  fields: AddLedgerBalanceMonitorFields;
  setFields: Dispatch<SetStateAction<AddLedgerBalanceMonitorFields>>;
}) {
  const { translatePrefix } = usePageConfigProviderContext();
  const { t } = useTranslation(translatePrefix);

  const array = [
    {
      label: t(TableColumnKey.ChainName),
      component: (
        <ChainNameSingleSelection
          value={fields.chainName}
          onChange={(chainName) =>
            setFields((prev) => ({
              ...prev,
              chainName,
              currency: "",
            }))
          }
        />
      ),
    },
    {
      label: t(TableColumnKey.Currency),
      component: (
        <CurrencySingleSelection
          value={fields.currency}
          onChange={(currency) => setFields((prev) => ({ ...prev, currency }))}
          chainName={fields.chainName}
        />
      ),
    },
    {
      label: t(TableColumnKey.ClientId),
      component: (
        <ClientIdTextField
          value={fields.clientId}
          onChange={(clientId) => setFields((prev) => ({ ...prev, clientId }))}
        />
      ),
    },
  ];

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        columnGap: "20px",
        rowGap: "28px",
        "& .MuiFormControl-root": {
          flex: 1,
        },
      }}
    >
      {array.map((item, index) => (
        <div
          key={index}
          style={{
            display: "grid",
            gridTemplateColumns: "100px 1fr",
            gap: "8px",
            fontSize: "12px",
            alignItems: "center",
          }}
        >
          <div style={{ lineHeight: "2rem" }}>{item.label}</div>
          {item.component}
        </div>
      ))}
    </Box>
  );
}

export default LedgerFieldSection;
